/** Load data for a screen: loading / error / data, with reload. The loading placeholder waits 300 ms (see Loading). */
import { useCallback, useEffect, useRef, useState } from "react";
import { errorSentence } from "./api";

export interface Load<T> { data: T | null; error: string | null; loading: boolean; reload: () => Promise<void>; setData: (d: T | ((prev: T | null) => T | null)) => void }
export function useLoad<T>(fn: () => Promise<T>, deps: unknown[] = []): Load<T> {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const fnRef = useRef(fn); fnRef.current = fn;
  const gen = useRef(0);
  const reload = useCallback(async () => {
    const g = ++gen.current; setLoading(true); setError(null);
    try { const d = await fnRef.current(); if (g === gen.current) { setData(d); setLoading(false); } }
    catch (e) { if (g === gen.current) { setError(errorSentence(e)); setLoading(false); } }
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { void reload(); }, deps);
  return { data, error, loading, reload, setData: setData as Load<T>["setData"] };
}
